<template>
    <q-list bordered style="max-width: 400px">
        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">Operator:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-skeleton type="text" v-if="loading && !transfer.operator"/>
                <q-item-label v-else>
                    {{transfer.operator}}
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Operator -->
        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">Margin:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-skeleton type="text" v-if="loading && !transfer.operator"/>
                <q-item-label v-else>
                    <currency-format :value="transfer.margin"
                                     hide-zero-decimal
                                     hide-white-spaces
                                     class="inline-block"
                                     :unit="transfer.from_currency"
                                     iso-unit
                    />
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Margin -->
        <q-separator spaced />

        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">Exchange:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-skeleton type="text" v-if="loading && !transfer.operator"/>
                <q-item-label v-else>
                    {{transfer.exchange}}
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Exchange -->
        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">We convert:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-skeleton type="text" v-if="loading && !transfer.operator"/>
                <q-item-label v-else>
                    <currency-format :value="transfer.convertible_amount"
                                     hide-zero-decimal
                                     hide-white-spaces
                                     class="inline-block"
                                     :unit="transfer.from_currency"
                                     iso-unit
                    />
                </q-item-label>
            </q-item-section>
        </q-item> <!-- We Convert -->
        <q-item v-if="!preventChangePrice">
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">Current price:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-item-label>
                    <q-input v-model="transfer.current_price" dense color="input-color" :readonly="preventChangePrice">
                        <template v-slot:prepend>
                            <small>{{transfer.from_currency}}</small>
                        </template>
                        <template v-slot:append>
                            <q-btn outline
                                   dense
                                   no-caps
                                   icon="fa fa-sync"
                                   label="Last Price"
                                   size="sm"
                                   color="positive"
                                   :loading="loading"
                                   @click="info"
                                   :disabled="preventChangePrice"
                            />
                        </template>
                    </q-input>
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Current price -->
        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">
                    Target price:
                    <q-tooltip  anchor="center right"
                                self="center left"
                                content-class="bg-yellow-1 text-black q-card--bordered border-black text-caption"
                                :offset="[-45, 10]"
                    >
                        Asset Buy/Sell price at the time of Order creation.
                    </q-tooltip>
                </q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-item-label>
                    <q-input readonly dense v-model="transfer.target_price" color="input-color" >
                        <template v-slot:prepend>
                            <small>{{transfer.from_currency}}</small>
                        </template>
                    </q-input>
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Target price -->
        <q-item>
            <q-item-section class="col-4">
                <q-item-label class="text-grey-7 text-weight-bolder">Amount to buy:</q-item-label>
            </q-item-section>

            <q-item-section class="text-right text-weight-bolder">
                <q-skeleton type="text" v-if="loading"/>
                <q-item-label v-else>
                    <currency-format :value="transfer.convertible_amount / transfer.current_price"
                                     hide-zero-decimal
                                     hide-white-spaces
                                     decimal-max-length="2"
                                     class="inline-block"
                                     :unit="transfer.asset"
                                     :iso-unit="false"
                    />
                </q-item-label>
            </q-item-section>
        </q-item> <!-- Amount to buy -->
    </q-list>
</template>
<script>

import Transfer from "../../models/Transfer"
export default {
    name: "OnRamp",
    props: {
        reference: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        preventChangePrice() {
            return ['transferred', 'canceled'].includes(this.status)
        }
    },
    data() {
        return {
            loading: false,
            transfer: {
                operator: undefined,
                margin: undefined,
                exchange: undefined,
                convertible_amount: 0,
                current_price: undefined,
                target_price: undefined,
                from_currency: undefined,
                asset: undefined,
            }
        }
    },
    methods: {
        info() {
            this.loading = true
            new Transfer({
                reference: this.reference
            }).getOnRampInfo((data) => {
                this.loading = false
                this.transfer = data
            }).catch(error => {
                this.loading = false
            })
        }
    },
    created() {
        this.info()
    },
    mounted() {

    },
    components: {},
}
</script>
<style>

</style>
